declare namespace $ {

	type $mol_number__value_bog_gamengine_demo_boxes_1 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['count'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__value_min_bog_gamengine_demo_boxes_2 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['value_min'] >
	>
	type $mol_button_minor__title_bog_gamengine_demo_boxes_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_gamengine_demo_boxes_4 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_gamengine_demo_boxes_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_gamengine_demo_boxes_6 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['chain'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_gamengine_demo_boxes_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_gamengine_demo_boxes_8 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['door'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_boxes_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_boxes_10 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['wireframe'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_boxes_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_boxes_12 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['contacts'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_boxes_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_boxes_14 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['paused'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type __bog_gamengine_demo_boxes_15 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_boxes['wireframe'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_boxes['Draw'] >['wireframe'] >[0]
	>
	type $bog_gamengine_draw__scene_bog_gamengine_demo_boxes_16 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Scene'] >
		,
		ReturnType< $bog_gamengine_draw['scene'] >
	>
	type $bog_gamengine_draw__cam_bog_gamengine_demo_boxes_17 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Walker'] >
		,
		ReturnType< $bog_gamengine_draw['cam'] >
	>
	type $bog_gamengine_draw__event_bog_gamengine_demo_boxes_18 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_gamengine_demo_boxes['shoot'] > ): ReturnType< $bog_gamengine_demo_boxes['shoot'] >,
			contextmenu( next?: ReturnType< $bog_gamengine_demo_boxes['dig'] > ): ReturnType< $bog_gamengine_demo_boxes['dig'] >,
		}) 
		,
		ReturnType< $bog_gamengine_draw['event'] >
	>
	type $mol_view__sub_bog_gamengine_demo_boxes_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_boxes_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_boxes_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type __bog_gamengine_demo_boxes_22 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_boxes['paused'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_boxes['Clock'] >['paused'] >[0]
	>
	type $bog_gamengine_shape_lines__points_bog_gamengine_demo_boxes_23 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['contact_points'] >
		,
		ReturnType< $bog_gamengine_shape_lines['points'] >
	>
	type $bog_gamengine_shape_lines__count_bog_gamengine_demo_boxes_24 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['contact_count'] >
		,
		ReturnType< $bog_gamengine_shape_lines['count'] >
	>
	type $bog_gamengine_shape_plane__tile_bog_gamengine_demo_boxes_25 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['floor_tile'] >
		,
		ReturnType< $bog_gamengine_shape_plane['tile'] >
	>
	type $bog_gamengine_input__key_bog_gamengine_demo_boxes_26 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Key'] >
		,
		ReturnType< $bog_gamengine_input['key'] >
	>
	type $bog_gamengine_key__bind_bog_gamengine_demo_boxes_27 = $mol_type_enforce<
		({ 
			'forward': readonly(any)[],
			'back': readonly(any)[],
			'left': readonly(any)[],
			'right': readonly(any)[],
			'turn_left': readonly(any)[],
			'turn_right': readonly(any)[],
		}) 
		,
		ReturnType< $bog_gamengine_key['bind'] >
	>
	type $bog_gamengine_atlas__uris_bog_gamengine_demo_boxes_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_atlas['uris'] >
	>
	type $bog_gamengine_atlas__size_bog_gamengine_demo_boxes_29 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_atlas['size'] >
	>
	type $bog_gamengine_scene__clock_bog_gamengine_demo_boxes_30 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Clock'] >
		,
		ReturnType< $bog_gamengine_scene['clock'] >
	>
	type $bog_gamengine_scene__input_bog_gamengine_demo_boxes_31 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Input'] >
		,
		ReturnType< $bog_gamengine_scene['input'] >
	>
	type $bog_gamengine_scene__kids_bog_gamengine_demo_boxes_32 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['nodes'] >
		,
		ReturnType< $bog_gamengine_scene['kids'] >
	>
	type $bog_gamengine_scene__phys3_bog_gamengine_demo_boxes_33 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Phys'] >
		,
		ReturnType< $bog_gamengine_scene['phys3'] >
	>
	type $bog_gamengine_scene__batches_bog_gamengine_demo_boxes_34 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['batches'] >
		,
		ReturnType< $bog_gamengine_scene['batches'] >
	>
	type $bog_gamengine_scene__cam_bog_gamengine_demo_boxes_35 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Walker'] >
		,
		ReturnType< $bog_gamengine_scene['cam'] >
	>
	type $bog_gamengine_scene__aspect_bog_gamengine_demo_boxes_36 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['aspect'] >
		,
		ReturnType< $bog_gamengine_scene['aspect'] >
	>
	type $bog_gamengine_scene__Shader_solid_bog_gamengine_demo_boxes_37 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Solid'] >
		,
		ReturnType< $bog_gamengine_scene['Shader_solid'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_demo_boxes_38 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Solid'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__shape_bog_gamengine_demo_boxes_39 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Box'] >
		,
		ReturnType< $bog_gamengine_batch['shape'] >
	>
	type $bog_gamengine_batch__atlas_bog_gamengine_demo_boxes_40 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Atlas'] >
		,
		ReturnType< $bog_gamengine_batch['atlas'] >
	>
	type $bog_gamengine_batch__source_bog_gamengine_demo_boxes_41 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Phys'] >
		,
		ReturnType< $bog_gamengine_batch['source'] >
	>
	type $bog_gamengine_batch__skip_bog_gamengine_demo_boxes_42 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_batch['skip'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_demo_boxes_43 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Flat'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__shape_bog_gamengine_demo_boxes_44 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Lines'] >
		,
		ReturnType< $bog_gamengine_batch['shape'] >
	>
	type $bog_gamengine_batch__instances_bog_gamengine_demo_boxes_45 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_batch['instances'] >
	>
	type $bog_gamengine_phys3_debug__phys3_bog_gamengine_demo_boxes_46 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Phys'] >
		,
		ReturnType< $bog_gamengine_phys3_debug['phys3'] >
	>
	type $bog_gamengine_mesh__shape_bog_gamengine_demo_boxes_47 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Plane'] >
		,
		ReturnType< $bog_gamengine_mesh['shape'] >
	>
	type $bog_gamengine_mesh__atlas_bog_gamengine_demo_boxes_48 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Atlas'] >
		,
		ReturnType< $bog_gamengine_mesh['atlas'] >
	>
	type $bog_gamengine_mesh__frame_bog_gamengine_demo_boxes_49 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_mesh['frame'] >
	>
	type $bog_gamengine_mesh__size_bog_gamengine_demo_boxes_50 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['floor_size'] >
		,
		ReturnType< $bog_gamengine_mesh['size'] >
	>
	type $bog_gamengine_phys3_body__name_bog_gamengine_demo_boxes_51 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_phys3_body['name'] >
	>
	type $bog_gamengine_demo_boxes_platform__name_bog_gamengine_demo_boxes_52 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_demo_boxes_platform['name'] >
	>
	type $bog_gamengine_demo_boxes_platform__phys3_bog_gamengine_demo_boxes_53 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Phys'] >
		,
		ReturnType< $bog_gamengine_demo_boxes_platform['phys3'] >
	>
	type $bog_gamengine_demo_boxes_platform__size_bog_gamengine_demo_boxes_54 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['platform_size'] >
		,
		ReturnType< $bog_gamengine_demo_boxes_platform['size'] >
	>
	type $bog_gamengine_demo_boxes_platform__mass_bog_gamengine_demo_boxes_55 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_boxes_platform['mass'] >
	>
	type $bog_gamengine_demo_boxes_platform__kinematic_bog_gamengine_demo_boxes_56 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_gamengine_demo_boxes_platform['kinematic'] >
	>
	type $bog_gamengine_demo_room_walker__input_bog_gamengine_demo_boxes_57 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['Input'] >
		,
		ReturnType< $bog_gamengine_demo_room_walker['input'] >
	>
	type $bog_gamengine_demo_room_walker__pos_bog_gamengine_demo_boxes_58 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['walker_pos'] >
		,
		ReturnType< $bog_gamengine_demo_room_walker['pos'] >
	>
	type $bog_gamengine_demo_room_walker__rot_bog_gamengine_demo_boxes_59 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_boxes['walker_rot'] >
		,
		ReturnType< $bog_gamengine_demo_room_walker['rot'] >
	>
	export class $bog_gamengine_demo_boxes extends $mol_page {
		count( next?: number ): number
		Count( ): $mol_number
		reset( next?: any ): any
		Reset( ): $mol_button_minor
		chain( next?: any ): any
		Chain( ): $mol_button_minor
		door( next?: any ): any
		Door( ): $mol_button_minor
		Wireframe( ): $mol_check_box
		contacts( next?: boolean ): boolean
		Contacts( ): $mol_check_box
		Pause( ): $mol_check_box
		wireframe( next?: ReturnType< ReturnType< $bog_gamengine_demo_boxes['Draw'] >['wireframe'] > ): ReturnType< ReturnType< $bog_gamengine_demo_boxes['Draw'] >['wireframe'] >
		stat( ): ReturnType< ReturnType< $bog_gamengine_demo_boxes['Draw'] >['stat'] >
		shoot( next?: any ): any
		dig( next?: any ): any
		Draw( ): $bog_gamengine_draw
		Stat( ): $mol_view
		phys_stat( ): string
		Phys_stat( ): $mol_view
		cull_stat( ): string
		Cull_stat( ): $mol_view
		paused( next?: ReturnType< ReturnType< $bog_gamengine_demo_boxes['Clock'] >['paused'] > ): ReturnType< ReturnType< $bog_gamengine_demo_boxes['Clock'] >['paused'] >
		nodes( ): readonly(any)[]
		batches( ): readonly(any)[]
		aspect( ): number
		Solid( ): $bog_gamengine_shader_solid
		Box( ): $bog_gamengine_shape_box
		Flat( ): $bog_gamengine_shader_flat
		contact_points( ): Float32Array
		contact_count( ): number
		Lines( ): $bog_gamengine_shape_lines
		floor_tile( ): Float32Array
		Plane( ): $bog_gamengine_shape_plane
		floor_size( ): Float32Array
		platform_size( ): Float32Array
		walker_pos( next?: Float32Array ): Float32Array
		walker_rot( next?: Float32Array ): Float32Array
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
		seed( next?: number ): number
		Input( ): $bog_gamengine_input
		Key( ): $bog_gamengine_key
		Atlas( ): $bog_gamengine_atlas
		Clock( ): $bog_gamengine_clock
		Phys( ): $bog_gamengine_demo_boxes_phys
		Scene( ): $bog_gamengine_scene
		Crates( ): $bog_gamengine_batch
		Contact_batch( ): $bog_gamengine_batch
		Debug( ): $bog_gamengine_phys3_debug
		Floor( ): $bog_gamengine_mesh
		Thrown( id: any): $bog_gamengine_phys3_body
		Platform( id: any): $bog_gamengine_demo_boxes_platform
		Walker( ): $bog_gamengine_demo_room_walker
	}
	
}

//# sourceMappingURL=boxes.view.tree.d.ts.map